import * as React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {Main} from '@pages';
import config from '@config';

export const Router = () => (

    <BrowserRouter>
        <Switch>
            <Route path={config.path.login.demoAccess} component={Main}/>
            <Route path={config.path.login.removeAccountRequest} component={Main}/>
            {/*<Route component={NotFound404}/>*/}
        </Switch>
    </BrowserRouter>
);